export enum TypeJeton {
  Recurrent = 0,
  Bonus = 1,
  Freemium = 2,
  Illimited = 3,
  Corpo = 4,
  AddByUser = 5
}
